/**
 * Initialize the configurations
 *
 */
var buildNumber = process.env.BUILD_NUMBER || "1";

console.log(`test library.io env: build: ${buildNumber}`);

var siteConfig = require("../shared/config/SiteConfig.js");
var SiteConfig = siteConfig(siteConfig.env(), buildNumber)
var ApplicationContext = require("../shared/config/ApplicationContext.js");
ApplicationContext.setup(SiteConfig);

var RegionUtil = require("../shared/util/RegionUtil.js");
RegionUtil.getRegions();

var BrowserDataStore = require("../datastore/BrowserDataStore.js");
var application = require("../shared/Application.js");
application.dataStore = new BrowserDataStore();

/**
 * Import required libraries
 */
var React = require("react");
var ReactDOM = require("react-dom");
var AppPage = require("../shared/pages/App.jsx");


window.fullHubAlias = "Managed Folder";
window.hubAlias = "Folder"

import { BrowserRouter } from 'react-router-dom'
ReactDOM.hydrate(
    <BrowserRouter >
        <AppPage {...{appData: __app.dataContext}}/>
    </BrowserRouter>,  document
);
